import { DISMISS_VIDEO_STORIES_OVERLAY, SHOW_VIDEO_STORIES_OVERLAY } from '../actions/VideoStory';
import { CREATE_TEMPLATE, REMOVE_TEMPLATE } from '../actions';
import { VIDEO_STORIES_OVERLAY_TEMPLATE } from '../types/templates/videoStoriesOverlay';
export const VideoStoriesMediaMiddleware = (store) => (next) => (action) => {
    var _a;
    switch (action.type) {
        case SHOW_VIDEO_STORIES_OVERLAY:
            store.dispatch({
                type: CREATE_TEMPLATE,
                payload: Object.assign(Object.assign({}, action.payload), { template: {
                        interface: VIDEO_STORIES_OVERLAY_TEMPLATE,
                    } }),
            });
            break;
        case DISMISS_VIDEO_STORIES_OVERLAY: {
            const videoStoryOverlayTemplates = store.getState().TemplateStack.overlayTemplates;
            const videoStoriesOverlayId = (_a = videoStoryOverlayTemplates[videoStoryOverlayTemplates.length - 1]) === null || _a === void 0 ? void 0 : _a.id;
            if (videoStoriesOverlayId) {
                store.dispatch({
                    type: REMOVE_TEMPLATE,
                    payload: Object.assign(Object.assign({}, action.payload), { owner: videoStoriesOverlayId }),
                });
            }
            break;
        }
        default:
            break;
    }
    next(action);
};
